import { Box, Button, Heading, Image, Text } from '@chakra-ui/react';
import { progressiveFormStepper } from '../../../components/ProgressiveFormStepper/utils';
import { exitToMenu } from '../../utils';
import React from 'react';

const Questions = ({ iu, styles }) => {

  let question = iu.props.stateProps.interviewTitle !== 'start' ? iu.props.stateProps.interviewTitle : 'Showcase Your Wins';
  question = iu.sectionName === 'interview-you' ? 'Perfect your elevator pitch.' : question;
  question = iu.sectionName === 'interview-questions' ? 'Show your interest.' : question;
  return (
    <Box sx={{ ...styles.interview }} width="80%" margin="0 auto">
      <Heading marginBottom="1rem">{question}</Heading>
      {window.appType === 'city' && (
        <Text>Watch this short video to learn more about how to develop your goals.</Text>
      )
      }
      <Box className="interviewWrapper">
        <Box area="form" className="interviewFormWrapper">
          <Box>
            <Box className="interviewCenter" paddingTop="10rem">
              <Box height="1rem"> </Box>
              {progressiveFormStepper(
                iu.props,
                iu.props.sections['questions'],
                iu.sectionIndex,
              )}
            </Box>
            <Box>
              <Button
                sx={{ ...styles.button.primary, ...styles.button.singleSectionMenu }}
                onClick={() => iu.exitToMenu(iu.props)}>
                &lt;&lt; Menu
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default Questions;

/*
        {(iu.sectionName !== 'interview-you' && iu.sectionname !== 'interview-questions' && iu.sectionName !== 'interview-sparl') && (
        <Box className="heroImageBox heroImageRight" width='40%' margin='3rem 5rem 0 0'>
          <Image className="heroImageImg" src={iu.interviewImage2} />
        </Box>
          )}

 */